import React, { useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { IMAGE_ACCEPT, prepareImageForUpload } from '../utils/imageUpload';

const ImageDropzone = ({
  inputName,
  label,
  imagePath,
  alt,
  onImageReady,
  prepareOptions,
  emptyPrompt = 'Drag and drop image here',
  showUploadButton = false,
}) => {
  const [previewPath, setPreviewPath] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    return () => {
      if (previewPath) URL.revokeObjectURL(previewPath);
    };
  }, [previewPath]);

  const onDrop = async (acceptedFiles) => {
    setError('');
    const file = acceptedFiles[0];
    if (!file) return;

    try {
      const preparedFile = await prepareImageForUpload(file, prepareOptions);
      const objectURL = URL.createObjectURL(preparedFile);
      setPreviewPath((currentPreviewPath) => {
        if (currentPreviewPath) URL.revokeObjectURL(currentPreviewPath);
        return objectURL;
      });
      await onImageReady({ name: preparedFile.name, uri: preparedFile });
    } catch (dropError) {
      console.error('Error preparing image:', dropError);
      setError(dropError.message || 'Could not prepare image.');
    }
  };

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      accept: IMAGE_ACCEPT,
      multiple: false,
    });

  const dzStyle = useMemo(
    () =>
      [
        'baseStyle',
        isFocused ? 'focusedStyle' : '',
        isDragAccept ? 'acceptStyle' : '',
        isDragReject ? 'rejectStyle' : '',
      ].join(' '),
    [isFocused, isDragAccept, isDragReject]
  );

  const displayPath = previewPath || imagePath;

  return (
    <section className="dzContainer mb-3">
      <div {...getRootProps()} className={dzStyle}>
        <input {...getInputProps({ id: inputName, name: inputName })} />
        {label && (
          <label className="form-label text-start" htmlFor={inputName}>
            {label}
          </label>
        )}
        {displayPath ? (
          <img src={displayPath} style={{ width: '100%' }} alt={alt} />
        ) : (
          <>
            <p>{emptyPrompt}</p>
            {showUploadButton && (
              <button type="button" className="btn btn-primary">
                Upload File
              </button>
            )}
          </>
        )}
        {error && <div className="text-danger small mt-2">{error}</div>}
      </div>
    </section>
  );
};

export default ImageDropzone;
